// When updating, make sure to update $colors in colors.scss
const lightColors = {
  "gray-3": "#989898",
  "gray-4": "#b0b0b0",
  "permanent-black": "#000000",
  "permanent-white": "#FFFFFF",
  "blue-2": "#1F6AD0",
  "blue-3": "#2F80ED",
  "blue-4": "#4E9AFF",
  "red-3": "#CD0000",
  "red-4": "#FE3C3C",
  "orange-3": "#F89A43",
  "green-3": "#22AB61",
  "yellow-2": "#EDAC04",
  "yellow-3": "#FFBD12",
  "yellow-4": "#FFD21E",
  "purple-3": "#9B51E0",
  "brown-3": "#9B5013",
  "cyan-3": "#6BC9CD",
  "pink-3": "#E161D2",
  "glyph-prm": "#000000",
  "glyph-scd": "#666666",
  "glyph-trt": "#BEBEBE",
  "glyph-cst-prm": "#FFFFFF",
  "glyph-cst-scd": "#939393",
  "glyph-cst-trt": "#AFAFAF",
  border: "#DADDE1",
  "surface-prm": "#FFFFFF",
  "surface-screen": "#FFFFFF",
  "surface-popover": "#FFFFFF",
  "surface-scd": "#EDEDED",
  "surface-trt": "#D9D9D9",
  "surface-cst": "#0A0A0A",
  "surface-cst-scd": "#3D3D3D",
  "surface-cst-scd-overlay": "#3D3D3D80",
  "surface-cst-trt": "#6B6B6B",
};

const darkColors = {
  "gray-3": "#898989",
  "gray-4": "#939393",
  "permanent-black": "#000000",
  "permanent-white": "#FFFFFF",
  "blue-2": "#1F6AD0",
  "blue-3": "#2F80ED",
  "blue-4": "#4E9AFF",
  "red-3": "#CD0000",
  "red-4": "#FE3C3C",
  "orange-3": "#F89A43",
  "green-3": "#22AB61",
  "yellow-2": "#EDAC04",
  "yellow-3": "#FFBD12",
  "yellow-4": "#FFD21E",
  "purple-3": "#9B51E0",
  "brown-3": "#9B5013",
  "cyan-3": "#6BC9CD",
  "pink-3": "#E161D2",
  "glyph-prm": "#FFFFFF",
  "glyph-scd": "#B5B5B5",
  "glyph-trt": "#676767",
  "glyph-cst-prm": "#000000",
  "glyph-cst-scd": "#666666",
  "glyph-cst-trt": "#BEBEBE",
  border: "#37372A",
  "surface-prm": "#171717",
  "surface-screen": "#0A0A0A",
  "surface-popover": "#262626",
  "surface-scd": "#2D2D2D",
  "surface-trt": "#6B6B6B",
  "surface-cst": "#FFFFFF",
  "surface-cst-scd": "#D4D4D4",
  "surface-cst-scd-overlay": "#D4D4D480",
  "surface-cst-trt": "#D9D9D9",
};

module.exports = { lightColors, darkColors };
